/* eslint-disable import/prefer-default-export */
import MUIAlert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';

export const Alert = styled(MUIAlert)`
	margin: ${({ theme }) => theme.spacing(2)} auto;
`;
